module.exports = __webpack_public_path__ + "ug.svg?8bcdae8b37a015a0870777d0b1e61fae";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ug.svg
// module id = 1213
// module chunks = 27